// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"300":"219f8eee","326":"404e638a","475":"e0ad3aa7","856":"7416c55d"}[chunkId] + ".css";
};